// Re-export every fixture and provide a Record<ScenarioName, Scenario> map.
// See plans/saas-billing/01-stripe-billing-foundation.md.

import { ScenarioName } from '../billing-mock.interface';
import { Scenario } from './scenario.types';
import { healthyMonthlyUs } from './healthy-monthly-us.fixture';
import { healthyAnnualNg } from './healthy-annual-ng.fixture';
import { pastDueUs } from './past-due-us.fixture';
import { pastDueUsYellow } from './past-due-us-yellow.fixture';
import { pastDueUsRed } from './past-due-us-red.fixture';
import { restrictedUs } from './restricted-us.fixture';
import { cancelledGracePeriodGb } from './cancelled-grace-period-gb.fixture';
import { cancelledGraceExpired } from './cancelled-grace-expired.fixture';
import { reverseChargeDe } from './reverse-charge-de.fixture';
import { newSignupIncomplete } from './new-signup-incomplete.fixture';

export {
  healthyMonthlyUs,
  healthyAnnualNg,
  pastDueUs,
  pastDueUsYellow,
  pastDueUsRed,
  restrictedUs,
  cancelledGracePeriodGb,
  cancelledGraceExpired,
  reverseChargeDe,
  newSignupIncomplete
};

export { Scenario } from './scenario.types';

export const SCENARIOS: Record<ScenarioName, Scenario> = {
  healthy_monthly_us: healthyMonthlyUs,
  healthy_annual_ng: healthyAnnualNg,
  past_due_us: pastDueUs,
  past_due_us_yellow: pastDueUsYellow,
  past_due_us_red: pastDueUsRed,
  restricted_us: restrictedUs,
  cancelled_grace_period_gb: cancelledGracePeriodGb,
  cancelled_grace_expired: cancelledGraceExpired,
  reverse_charge_de: reverseChargeDe,
  new_signup_incomplete: newSignupIncomplete
};

export const ALL_SCENARIO_NAMES: ScenarioName[] = [
  'healthy_monthly_us',
  'healthy_annual_ng',
  'past_due_us',
  'past_due_us_yellow',
  'past_due_us_red',
  'restricted_us',
  'cancelled_grace_period_gb',
  'cancelled_grace_expired',
  'reverse_charge_de',
  'new_signup_incomplete'
];
